import { STAFF_ROLES, type Role } from '../pages/users/types/rbac';

export function isStaffAddClientSelfAssignRole(role: Role): boolean {
  return role === 'provider' || role === 'supervisor';
}

export function canRoleAddClient(role: Role): boolean {
  return STAFF_ROLES.includes(role) || isStaffAddClientSelfAssignRole(role);
}
